export enum OfferHistorySortOrderEnums {
    ASC = 'asc',
    DESC = 'desc'
  }
  